import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "base-icon-menu" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "menus" }
const _hoisted_4 = ["onMouseover", "onClick"]
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "content" }

import { computed, ref } from "vue";
import { svgIcon, baseTooltip } from "@/common/components";

interface TabType {
  icon: string;
  label?: string;
  key?: string;
  url?: string;
  active?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'icon-menu',
  props: {
    tabs: {},
    active: { default: "" },
    size: { default: "2.25rem" },
    showClose: { type: Boolean, default: false }
  },
  emits: ["selected", "close"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v6cf8b85a": (_ctx.size)
}))

const emit = __emit;

const props = __props;

const tabHover = ref<number | null>(null);

const tabList = computed(() => {
  let found = false;
  const list: TabType[] = [];

  props.tabs?.forEach((tab) => {
    list.push({ ...tab, active: !found });

    if (tab.key === props.active) {
      found = true;
    }
  });

  return list;
});

function selectTab(data: TabType) {
  if (data.url) {
    emit("selected", data.url);
    return;
  }

  if (data.key) {
    emit("selected", data.key);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (tab, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (index != 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["separate", { active: tab.active }])
                }, null, 2))
              : _createCommentVNode("", true),
            _createVNode(_unref(baseTooltip), null, _createSlots({
              trigger: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["menu", { active: tab.active }]),
                  onMouseover: ($event: any) => (tabHover.value = index),
                  onMouseout: _cache[0] || (_cache[0] = ($event: any) => (tabHover.value = null)),
                  onClick: ($event: any) => (selectTab(tab))
                }, [
                  _createVNode(_unref(svgIcon), {
                    icon: tab.icon,
                    size: "90%"
                  }, null, 8, ["icon"])
                ], 42, _hoisted_4)
              ]),
              _: 2
            }, [
              (tab.label)
                ? {
                    name: "tooltip",
                    fn: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(tab.label), 1)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1024)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (__props.showClose)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-lg btn-default",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "close",
                size: "1.25rem"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "content")
    ])
  ]))
}
}

})